module.exports = __webpack_public_path__ + "img/4.246093e3.jpg";